import React from "react";
import OkendoStarRating from "components/okendo/star-rating";
import Money from "components/money";
import useIsSticky from "hooks/useIsSticky";
import { scrollToElementById } from "helpers/scroll";
import { reviewsWidgetId } from "utils/constants";
import clsx from "clsx/lite";
import Link from "components/link";
import { trackPDPCollectionClick } from "analytics";

const StockStatus = ({ availabilityDetails }) => {
	const { preorder, isAvailable } = availabilityDetails || {};
	const statusText = preorder ? "Pre-Order" : (isAvailable ? "In stock" : "Out of stock");

	const statusClass = clsx(
		"text-sm flex items-center gap-1 px-2 py-0.5 rounded-md whitespace-nowrap",
		isAvailable && !preorder ? "text-kellyGreen bg-[#F4FDE7]" : "bg-[#EBEBEB80] text-gray-700",
		preorder && "!bg-[#EBEBEB80] ml-auto"
	);

	const statusIconClass = clsx(
		"flex size-2.5 rounded-full",
		isAvailable && !preorder ? "bg-kellyGreen" : "bg-red-500",
		preorder && "!bg-[#E5B65C]"
	);

	return (
		<span className={statusClass}>
			<span className={statusIconClass}></span>
			{statusText}
		</span>
	);
};

const ProductSummary = ({ product, sticky }) => {
	const isSticky = sticky && useIsSticky({ mobileOnly: true });
	const { title, type, reviewAggregate, variant, relatedCollection } = product;
	const { handle, title: collectionTitle } = relatedCollection ?? {};


	return (
		<div className={clsx(
			"product-summary",
			sticky ? "px-4 py-4 top-0 bg-white md:hidden" : "hidden md:flex pb-6",
			isSticky && "sticky-element !top-[66px] !z-[19] animate-slideInFromTop",
		)}
		>
			<div className="flex flex-col w-full">
				<div className="flex justify-between w-full">
					<div className="flex flex-col items-start">
						<h1 className="font-bold md:font-medium pb-2 text-start md:pr-5 text-h3-xs md:text-h3">{title}</h1>
						<p className="text-secondary uppercase text-sm">{type}</p>
						<button onClick={() => scrollToElementById(reviewsWidgetId)} >
							<OkendoStarRating reviewAggregate={reviewAggregate} />
						</button>
						{handle && <p className="text-darkGray text-sm pt-2.5">Shop <Link className="underline"
							onClick={() => trackPDPCollectionClick(title, collectionTitle)}
							to={`/collections/${handle}`}>{collectionTitle}</Link></p>}
					</div>
					<div className="flex flex-col items-end justify-end">
						<StockStatus availabilityDetails={{ ...variant.availability, isAvailable: variant?.isAvailable }} />
						<p className="font-bold md:font-semibold text-xl md:text-3xl mb-0 pb-0 w-fit text-right">
							<Money value={variant?.price} markets={variant?.markets} />
						</p>

						{variant?.compareAtPrice > variant?.price &&
							<div className="flex flex-wrap justify-end items-end gap-x-1 mt-1">
								<span className="line-through text-sm text-secondary">
									<Money value={variant.compareAtPrice} markets={variant.markets} compareAtPrice />
								</span>
								<span className="text-sm text-secondary unit-v-2"> / Unit</span>
							</div>
						}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProductSummary;